(function ($) {
  'use strict';

  window.selectDonationVariantCard = function (el) {
    var $el = $(el);
    var variantId = $el.data('variant-id');
    var $options = $el.closest('.x-donations-v2__variant-cards');
    var $row = $el.closest('tr');

    if ($options.length) {
      $options.find('.x-product-v2__opt').removeClass('is--active');
    }
    $el.addClass('is--active');

    var $select = $row.find('.x-product__select-variant');
    if (!$select.length && $options.length) {
      $select = $options.next('.x-product__select-variant');
    }
    if (!$select.length) {
      $select = $row.find('.x-donations__product .x-product__select-variant');
    }

    if ($select.length) {
      $select.val(String(variantId)).trigger('change');
    }

    $row.find('.x-form__checkbox').attr('data-variant-id', variantId);
  };

  function initDonationVariantCards() {
    $('.x-donations-v2__variant-cards .x-product-v2__opt.is--active').each(function () {
      var variantId = $(this).data('variant-id');
      if (!variantId) return;
      $(this).closest('tr').find('.x-form__checkbox').attr('data-variant-id', variantId);
    });
  }

  $(initDonationVariantCards);
})(jQuery);
